import React, {useState, useEffect} from "react";
import { useChat } from "../contexts/ChatProvider";
import {
  MinChatUiProvider,
  MainContainer,
  MessageContainer,
  MessageHeader,
} from "@minchat/react-chat-ui";
import MessageInput from './message-input';
import MessageList from "./message/MessageList";
import CrossIcon from './icons/CrossIcon';
import FullScreenIcon from "./icons/FullScreenIcon";

export const MinimizedAndMobileWidget = ({remoteName = "", onSend, onScreenExpand}) => {
  const { hide, theme, colorSet, loading, header, showTypingIndicator, enterFullScreen, isMobile} = useChat();

  const handleExitFullScreen = () => {
    enterFullScreen();
    onScreenExpand();
  }

  return (
      <div className="chatbot-container shadow-gray-400 shadow-md relative md:w-96 bg-white rounded-xl shadow-md shadow-gray-400 md:mr-6">
        <MinChatUiProvider
            theme={theme}
            colorSet={colorSet}
        >
          <MainContainer>
            <MessageContainer>
              <MessageHeader showBack={false}>
                <div style={{display:"flex", justifyContent:"space-between", padding:"0 5% 0 5%"}}>
                  <p id="ChatBotTitle">
                    { header }
                  </p>
                  <div style={{display:"flex", justifyContent:"start", gap:"15px"}}>
                    <span 
                      className="header-action"
                      onClick={()=>{hide()}}
                      style={{"--theme-color": theme, cursor: 'pointer', borderRadius: '50%'}}
                    >
                      <CrossIcon color={colorSet["--message-header-text-color"] ?? "black"}/>
                    </span>
                    {!isMobile && (<span 
                      className="header-action"
                      onClick={handleExitFullScreen}
                      style={{"--theme-color": theme, cursor: 'pointer', borderRadius: '50%'}}
                    > 
                      <FullScreenIcon color={colorSet["--message-header-text-color"] ?? "black"}/>
                    </span>)}
                  </div>
                </div>
              </MessageHeader>
              <MessageList
                  loading={loading}
                  onSendMessage={onSend}
              >
              </MessageList>
              <MessageInput
                placeholder="ここにメッセージを入力してください"
                onSendMessage={onSend}
                showAttachButton={false}
                disabled={showTypingIndicator}
              />
            </MessageContainer>
          </MainContainer>
        </MinChatUiProvider>
      </div>

  );
};